// OnePointMarker.js
import { GalleryMarkerBase } from './GalleryMarkerBase.js';

export class OnePointMarker extends GalleryMarkerBase {
    draw(map) {
        const latLng = this.mapAdapter.createLatLng(this.points[0]);

        const originMarker = this.createOriginMarker(latLng);
        this.drawnElements.push(originMarker);
    }
}
